import {Dialog, DialogContent, DialogMaxWidth} from 'components/UIKit';

type Props = {
    open: boolean;
    title?: string | React.ReactElement;
    maxWidth?: DialogMaxWidth;
    fullWidth?: boolean;
    className?: string;
    closeTimeoutMS?: number;
    children: React.ReactNode;
    onClose: () => void;
};

export const InformationModal = ({open, title, maxWidth = 'xs', fullWidth, className, children, onClose, closeTimeoutMS}: Props) => (
    <Dialog
        className={className}
        title={title}
        open={open}
        maxWidth={maxWidth}
        fullWidth={fullWidth}
        closeIcon
        closeTimeoutMS={closeTimeoutMS}
        onClose={onClose}
    >
        <DialogContent>{children}</DialogContent>
    </Dialog>
);
